
import Vue, { PropType } from 'vue';
import { Icon, Button, ActivityMessage } from '@descomplica/vue-components';
import { getPaddedDisplayNumber } from '@/helpers/string';
import Constants from '../settings/ui';
import StatusCircle from './StatusCircle.vue';
import { UserListActivityStatus } from '@/services/UndergradGrades';
import DueDateWarningHelper from '@/helpers/assessments/dueDateWarning';
import { TranslateResult } from 'vue-i18n';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { getCourseCategory } from '@/helpers/category';
import { ANALYTICS_LABELS } from '@/helpers/listItems';

interface Data {
  white: string;
}

export default Vue.extend({
  components: {
    Icon,
    StatusCircle,
    Button,
    ActivityMessage,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    successes: {
      type: Number,
      required: true,
    },
    mistakes: {
      type: Number,
      required: true,
    },
    listStatus: {
      type: Object as PropType<UserListActivityStatus>,
      default: null,
    },
  },
  data(): Data {
    return {
      white: Constants.colorPalette.white,
    };
  },
  computed: {
    activityStatus(): string {
      return DueDateWarningHelper.getActivityStatus(this.listStatus.status);
    },
    statusMessage(): TranslateResult {
      if (!this.listStatus?.dueDate) return '';
      return DueDateWarningHelper.getReviewListWarningMessage(
        this.listStatus?.status,
        this.isPastDue,
        new Date(this.listStatus?.dueDate),
      );
    },
    isPastDue(): boolean {
      const { answeredAt, dueDate, status } = this.listStatus;
      return DueDateWarningHelper.isPastDue(dueDate, answeredAt, status);
    },
  },
  mounted() {
    if (this.listStatus) this.trackingActivityMessageView();
  },
  methods: {
    getPaddedDisplayNumber,
    goToRevision() {
      this.$router.push({
        name: 'revision',
        params: {
          revisionSlug: this.$route.params.revisionSlug,
          classroomSlug: this.$route.params.classroomSlug,
        },
      });
    },
    trackingActivityMessageView(): void {
      Analytics.trackEvent(EVENT_LABELS.activityDeadlineView, {
        course: this.$store.getters.currentCourse.name,
        category: getCourseCategory(this.$store.getters.currentCourse),
        content_type: ANALYTICS_LABELS.revisionList,
        lesson_slug: this.$route.params.revisionSlug,
        discipline_slug: this.$route.params.classroomSlug,
        activity_status: this.listStatus.status,
      });
    },
  },
});
